<template>
    <div class="form-horizontal">
        <div class="form-group" >
            <label for="subscription-type-options" class="col-xs-12 col-md-4 control-label">{{ $t('components.subscription.title_name') }}</label>
            <div class="col-xs-12 col-md-8">
                <select class="form-control" id="subscription-type-options" name="subscription-type-options" :disabled="newSubscription.creditCardCheckout" v-model="newSubscription.type">
                    <option v-for="subscriptionType in subscriptionTypeAvailable" v-bind:key="subscriptionType.id" :value="subscriptionType">
                        {{subscriptionType.name}}
                    </option>
                </select>
            </div>
        </div>
        <div class="form-group" v-show="isSelectedNormal">
            <label for="date_new_subscription" class="col-xs-12 col-md-4 control-label">{{ $t('components.subscription.from') }}</label>
            <div class="col-xs-12 col-md-8 has-feedback" >
                <Datetime id="date_new_subscription"
                          type="date"
                          :value-zone="TIMEZONE_DEFAULT"
                          :zone="TIMEZONE_DEFAULT"
                          :disabled="newSubscription.creditCardCheckout"
                          v-model="newSubscription.start_date"
                          :phrases="{ok: $t('common.time.choose_datetime'), cancel: $t('common.time.cancel_datetime')}"
                          input-class="form-control"></Datetime>
                <span class="glyphicon glyphicon-calendar form-control-feedback" aria-hidden="true"></span>
            </div>
        </div>
        <div class="form-group">
            <label for="payment_mode_new_subscription" class="col-xs-12 col-md-4 control-label">{{ $t('common.payment') }}</label>
            <div class="col-xs-12 col-md-8">
                <select class="form-control" id="payment_mode_new_subscription" :disabled="newSubscription.creditCardCheckout" v-model="newSubscription.payment_mode">
                    <option v-for="paymentMode in paymentModeOptions" :key="paymentMode.value"
                            :value="paymentMode.value">{{paymentMode.name}}</option>
                </select>
            </div>
        </div>
        <div class="form-group" v-if="newSubscription.payment_mode !== PAYMENT_MODE.CREDIT_CARD && !newSubscription.creditCardCheckout">
            <label for="price_new_subscription" class="col-xs-12 col-md-4 control-label">{{ $t('common.price') }}</label>
            <div class="col-xs-12 col-md-8">
                <p class="form-control-static" id="price_new_subscription">{{getCurrencySymbolFromString(price_currency)}}{{price}}</p>
            </div>
        </div>
        <div class="form-group">
            <label for="subscription_email_notify" class="col-xs-12 col-md-4 control-label"></label>
            <div class="col-xs-12 col-md-8">
                <div class="checkbox">
                    <label>
                        <input type="checkbox" id="subscription_email_notify" name="subscription_email_notify" v-model="newSubscription.notify"> {{ $t('common.send_notification_question') }}
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Datetime} from "vue-datetime";
    import 'vue-datetime/dist/vue-datetime.css'
    import {PAYMENT_MODE, PAYMENT_MODE_OPTIONS, SUBSCRIPTION_CATEGORY, TIMEZONE_DEFAULT} from "../../common/constants";
    import {moveUpDatetimePopup, Utils} from "@/common/utils";
    import {StorageHelper} from "../../common/storageHelper";
    export default {
        name: "SubscriptionForm",
        components: {Datetime},
        props: {
            newSubscriptionProp: {
                type: Object,
                required: true
            },
            subscriptionTypeAvailable: {
                type: Array,
                default() {
                    return []
                }
            },
            TIMEZONE_DEFAULT: StorageHelper.getUser().timezone || TIMEZONE_DEFAULT
        },
        computed: {
            isSelectedNormal() {
                if (this.newSubscription.type) {
                    if (this.newSubscription.type.category === SUBSCRIPTION_CATEGORY.NORMAL) {
                        return true
                    }
                }
                return false;
            }
        },
        data: () => {
            return {
                newSubscription: {
                    type: null,
                    start_date: null,
                    payment_mode: null,
                    creditCardCheckout: false,
                    notify: true
                },
                price: "0.00",
                price_currency: "",
                PAYMENT_MODE: PAYMENT_MODE,
                paymentModeOptions: PAYMENT_MODE_OPTIONS(),
            }
        },
        mounted: function () {
            this.newSubscription = this.newSubscriptionProp;
            let date = new Date();

            this.newSubscription.start_date = date.toISOString();
            this.newSubscription.payment_mode = PAYMENT_MODE.CASH;

            moveUpDatetimePopup()
        },
        watch: {
            newSubscriptionProp: function(newVal) {
                this.newSubscription = newVal;
            },
            subscriptionTypeAvailable: function(newVal) {
                if (newVal.length > 0) {
                    this.newSubscription.type = newVal[0]
                }
            },
            newSubscription: {
                handler(newVal) {
                    this.$emit('change', newVal)
                },
                deep: true,
            },
            'newSubscription.type'(newVal) {
                this.price = newVal.price
                this.price_currency = newVal.price_currency
            }
        },
        methods: {
            getCurrencySymbolFromString(currency) {
                return Utils.getCurrencySymbolFromString(currency)
            }
        }
    }
</script>